export const catalogProducts = [
  {
    id: "prod-roblox",
    title: "Roblox Game Development",
    category: "Game Dev",
    badge: "Spesialis Studio",
    tagline: "Pengembangan game Roblox custom dari mekanik gameplay hingga aset 3D teroptimasi.",
    price: "Mulai Rp 3.000.000",
    features: [
      "Mekanik gameplay solid & custom scripting (Luau)",
      "Environment 3D & map building teroptimasi",
      "Sistem game pass, monetize, & inventory",
      "UI in-game ramah pemain PC & mobile",
      "Pengujian multiplayer & performa anti-lag",
    ],
    waMessage:
      "Halo Titik Senyap Studio, saya ingin memesan layanan *Roblox Game Development*. Bisa diskusikan ide konsep game dan tahapan pengerjaannya?",
  },
  {
    id: "prod-web",
    title: "Website Development",
    category: "Development",
    badge: "Rekomendasi",
    tagline: "Landing page hingga sistem web interaktif berkinerja tinggi dan responsif.",
    price: "Mulai Rp 2.500.000",
    features: [
      "Responsif di mobile, tablet, & desktop",
      "Performa cepat, SEO friendly, & clean code",
      "Integrasi API & database modern",
      "Setup domain, hosting / deployment siap pakai",
      "Garansi pemeliharaan & konsultasi teknis",
    ],
    waMessage:
      "Halo Titik Senyap Studio, saya ingin membuat *Website Development*. Apakah bisa berdiskusi lebih lanjut mengenai fitur dan paket pembuatannya?",
  },
  {
    id: "prod-mobile",
    title: "Mobile App Development",
    category: "Development",
    badge: "Favorit",
    tagline: "Aplikasi Android & iOS yang stabil, intuitif, dan siap rilis ke publik.",
    price: "Mulai Rp 4.500.000",
    features: [
      "Multiplatform (Flutter / Native)",
      "Desain antarmuka mulus dan responsif",
      "Integrasi backend, auth, & push notification",
      "Bantuan rilis ke Google Play Store & App Store",
      "Dukungan teknis pasca rilis",
    ],
    waMessage:
      "Halo Titik Senyap Studio, saya tertarik memesan layanan *Mobile App Development*. Ingin konsultasi spesifikasi aplikasi dan estimasi biayanya.",
  },
  {
    id: "prod-uiux",
    title: "Product Design & UI/UX",
    category: "Design",
    badge: "Populer",
    tagline: "Desain antarmuka modern, interaktif, dan fokus pada kenyamanan pengguna.",
    price: "Mulai Rp 1.500.000",
    features: [
      "Riset pengguna & user flow menyeluruh",
      "Wireframing & High-Fidelity Prototype (Figma)",
      "Design system & komponen modular yang rapi",
      "Siap handoff ke developer (clean specs)",
      "Revisi fleksibel sesuai kebutuhan brand",
    ],
    waMessage:
      "Halo Titik Senyap Studio, saya tertarik untuk memesan layanan *Product Design & UI/UX*. Boleh konsultasi mengenai detail alur dan estimasi waktu pengerjaannya?",
  },
  {
    id: "prod-ar",
    title: "Augmented Reality (AR)",
    category: "Immersive Tech",
    badge: "Inovatif",
    tagline: "Visualisasi digital interaktif yang menyatu natural dengan dunia nyata.",
    price: "Mulai Rp 3.500.000",
    features: [
      "Filter interaktif media sosial / WebAR berbasis browser",
      "Model 3D interaktif bertekstur realistis",
      "Deteksi permukaan & tracking presisi",
      "Cocok untuk katalog produk, edukasi, & pameran",
      "Dukungan integrasi platform digital",
    ],
    waMessage:
      "Halo Titik Senyap Studio, saya berencana membuat project *Augmented Reality (AR)*. Boleh info lengkap mengenai workflow dan harga paketnya?",
  },
];
